<template>
    <div id="dashboard-main">
        <div class="quote-page">
            <div class="quote-card">

                <!-- 顶部报价类型切换 -->
                <div class="quote-type">
                    <div v-for="item in quoteTypes" :key="item.value"
                        :class="['type-item', activeType === item.value ? 'active' : '']"
                        @click="handleChange(item.value)">
                        <div class="type-title">{{ item.label }}</div>
                        <div class="type-desc">{{ item.desc }}</div>
                    </div>
                </div>

                <!-- 表单区域动画 -->
                <div class="form-wrapper">
                    <transition :name="transitionName">
                        <component :is="currentComponent" :key="activeType" @switching="handleChange"   />
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { ref, reactive, defineAsyncComponent, computed } from 'vue'
    import { ElMessage, FormInstance, FormRules } from 'element-plus'
    import { useRouter, useRoute } from 'vue-router';
    
    const route = useRoute();
    const router = useRouter();
    
    const rapid = defineAsyncComponent(() => import('@/components/quotation/rapid.vue'));
    const standard = defineAsyncComponent(() => import('@/components/quotation/standard.vue'));
    const list = defineAsyncComponent(() => import('@/components/quotation/list.vue'));
    const precise = defineAsyncComponent(() => import('@/components/quotation/precise.vue'));

    const rapidRef = ref(null)
    const standardRef = ref(null)
    const listRef = ref(null)
    const preciseRef = ref(null)
    /* ===== 报价类型 ===== */
    const activeType = ref('quick')
    const transitionName = ref('slide-left')
    const currentStep = ref(1)
    const amountNumber = ref(6782342345)
    const componentMap = {
        quick: rapid,
        standard: standard,
        list: list,
        precise: precise
    }
    const quoteTypes = [
        {
            label: '快速估算',
            value: 'quick',
            desc: '适用于根据建筑基本信息，快速估算市场价'
        },
        {
            label: '标准报价',
            value: 'standard',
            desc: '适用于根据楼层设备信息，提供楼控系统配置，快速估算市场价'
        },
        {
            label: '清单报价',
            value: 'list',
            desc: '适用于根据系统清单信息，提供楼控系统配置，快速估算市场价'
        },
        {
            label: '点表报价',
            value: 'precise',
            desc: '适用于根据系统点表信息，提供楼控系统配置，快速估算市场价'
        }
    ]
    const currentComponent = computed(() => {
        return componentMap[activeType.value]
    })
    const typeOrder = ['quick', 'standard', 'list', 'precise']
    const handleChange = (newType) => {
        if (!sessionStorage.getItem('token')){
            ElMessage.error('请先登录！');
            router.replace('/login');
        }
        const oldIndex = typeOrder.indexOf(activeType.value)
        const newIndex = typeOrder.indexOf(newType)
        console.log('oldIndex:', oldIndex, 'newIndex:', newIndex);

        transitionName.value =
            newIndex > oldIndex ? 'slide-left' : 'slide-right'

        activeType.value = newType
    }
</script>

<style scoped>
    .quote-page {
        display: flex;
        justify-content: center;
    }

    .quote-card {
        width: 100%;
        padding: 10px 160px;
    }

    /* ===== 顶部类型选择 ===== */
    .quote-type {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .type-item {
        width: 20%;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
        background: #fff;
    }

    .type-item:hover {
        border-color: #409eff;
    }

    .type-item.active {
        background: #409eff;
        color: #fff;
        border-color: #409eff;
    }

    .type-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .type-desc {
        font-size: 13px;
        opacity: 0.8;
    }

    .form-wrapper {
        position: relative;
    }

    .form-wrapper>* {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
    }



    /* ===== 左滑 ===== */
    .slide-left-enter-from {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-left-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-left-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-left-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    /* ===== 右滑 ===== */
    .slide-right-enter-from {
        transform: translateX(-100%);
        opacity: 0;
    }

    .slide-right-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-right-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    /* 动画时长 */
    .slide-left-enter-active,
    .slide-left-leave-active,
    .slide-right-enter-active,
    .slide-right-leave-active {
        transition: transform 0.35s cubic-bezier(.4, 0, .2, 1);
        will-change: transform;
    }
</style>